import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisableImageCachingDirective } from './directives/disable-image-caching.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [DisableImageCachingDirective],
  exports: [DisableImageCachingDirective],
})
export class SharedUtilsDisableImageCachingModule {}
